/** @jsx jsx */
import { jsx } from "@emotion/react";
import { FC } from "react";
import { Icon } from "@material-ui/core";
import {
  BOTH,
  ICON,
  NORMAL,
  TEXT,
} from "../../../../TemplateBuilder/TemplateItemEditor/FormatEditor/constants";
import { TableColumn } from "../../../../../../requests/table/types";
import { AttributeFormat } from "../../../../../../requests/templates/types";
import { Cell, labelCellCss } from "./styles";

const LabelCell: FC<Props> = ({ column, format }) => {
  const { icon, mobileVariant, textAlign } = format;

  const displayIcon =
    icon && (mobileVariant === ICON || mobileVariant === BOTH);
  const displayText = mobileVariant === TEXT || mobileVariant === BOTH;

  const { displayName } = column;

  return (
    <Cell textAlign={textAlign} fontWeight={NORMAL} css={labelCellCss}>
      {displayText && displayName}
      {displayIcon && <Icon>{icon}</Icon>}
    </Cell>
  );
};

export type Props = {
  format: AttributeFormat;
  column: TableColumn;
};

export default LabelCell;
export type LabelCellProps = Props;
